import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { FormHelperService } from '../../../services/form-helper.service';
import { DxFormTypes } from 'devextreme-angular/ui/form';
import { DropdownService } from '../../../services/dropdown-service';
import { Service } from '../../../components/utils/models/service';
import { RichFormComponent } from '../../../components/library/rich-form/rich-form.component';
import dxTagBox from 'devextreme/ui/tag_box';
import { DxTagBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-register-merchant-services',
  templateUrl: './register-merchant-services.component.html',
  styleUrl: './register-merchant-services.component.scss'
})
export class RegisterMerchantServicesComponent {

  @Input() formGroupName!: string;
  @Input() serviceTypes!: Array<string>;
  servicesForm!: FormGroup;
  labelLocation: DxFormTypes.LabelLocation = 'left';
  services! : Array<Service>;
  @Output() notifyContainerDataChanged = new EventEmitter<any>();
  UISelectedItems: any[] = []
  @ViewChild('ServicesTagBox', { static: false }) serviceTagBox!: DxTagBoxComponent;
  
  constructor(
    private formGroupDirective: FormGroupDirective,
    private _dropDownService : DropdownService,
    
  ) {}

  ngOnInit(): void 
  {
    this.servicesForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
    this._dropDownService.GetServices()
    .subscribe(
      (data: Service[]) => { 
        this.services = data;
        this.services = this.services.sort((a, b) => {
          return a.name.localeCompare(b.name)
        });
      },
      (error :any) => {
        console.error('Error fetching services')
      }
    )
  }

  handleFormFieldsChange(event:any)
  {
    if ('dataField' in event)
    {

      this.servicesForm.patchValue({
        'Wallets': event.value
      });

      this.notifyParentChildChanged()
    }
    
  }

  handleTagBoxChange(event: any) {
    
    this.servicesForm.patchValue({
      'ServicesSelected': event.value
    });
    
    this.notifyParentChildChanged();
  }


  cancel() {

    this.servicesForm.reset();
    this.servicesForm.patchValue({ 'Wallets': 1 });
    if (this.serviceTagBox.instance){
      this.serviceTagBox.instance.reset();
    }
  }

  notifyParentChildChanged()
  {
    this.notifyContainerDataChanged.emit({
      FormType: 'Services'
    });
  }

  

}
